import React from "react";
export default function GlobTool({ payload, result }) {
  return (
    <div className="tool-card-body">
      <div className="tool-section">
        <h5>Pattern</h5>
        <pre className="tool-pre">{payload?.input?.pattern || ""}</pre>
      </div>
      {result && (
        <div className="tool-section">
          <h5>Matches</h5>
          <pre className="tool-pre">{result.content_preview || ""}</pre>
        </div>
      )}
    </div>
  );
}
GlobTool.summarize = (p) => p?.input?.pattern || "";
